"use client";

import { useEffect, useState } from "react";

/**
 * Returns `true` when running inside the Tauri desktop wrapper,
 * `false` on web / during SSR.
 *
 * Always returns `false` on the first render so React hydration
 * matches the server-rendered HTML. Flips to `true` after mount when
 * `window.__TAURI_INTERNALS__` is present. Also sets
 * `documentElement.dataset.desktop = "true"` so plain CSS can target
 * the whole tree via `html[data-desktop="true"] …` rules.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const w = window as unknown as {
      __TAURI_INTERNALS__?: unknown;
      __TAURI__?: unknown;
    };
    if (w.__TAURI_INTERNALS__ || w.__TAURI__) {
      setIsDesktop(true);
      document.documentElement.dataset.desktop = "true";
    }
  }, []);
  return isDesktop;
}
